export function getScoreHealthRangeTermMaxRangeValue(sectionMin: number) {
  return sectionMin * 4;
}
